<template>
  <div class="footer">
    <ul class="footer-nav">
      <li @click="toHome" style="cursor:pointer">首页<span></span></li>
      <!-- <li @click="$router.push({path:'/solution',query:{page:2}})" style="cursor:pointer">解决方案<span></span></li> -->
      <li @click="$router.push({path:'/proproducts'})" style="cursor:pointer">产品展示<span></span></li>
      <li @click="$router.push({path:'/newscenter'})" style="cursor:pointer">新闻中心<span></span></li>
      <!-- <li @click="$router.push({path:'/course'})" style="cursor:pointer">课程介绍<span></span></li> -->
      <li @click="$router.push({path:'/about'})" style="cursor:pointer">关于我们</li>
    </ul>
    <div class="wid1200">
      <div class="footer-box">
        <div>
          <p>名 称：北京博奥网络教育科技股份有限公司</p>
          <p>电 话：400-9999-355</p>
          <p>地 址：北京市朝阳区东坝中街13号院4号楼</p>
        </div>
        <div>
          <img
            style="width: 150px; position: relative; top: -30px"
            src="../assets/images/weixin.jpg"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="copyright">
      <div class="wid1200 cpy_box">
        <p class="cpry fl">
          Copyright 2017 版权所有©
          <a href="https://beian.miit.gov.cn"
          target="_blank"
            >京ICP备10211073号-6</a
          ><a
            href="https://beian.miit.gov.cn"
            target="_blank"
            >京公网安备 11010502049011号</a
          >
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    toHome () {
      this.$router.push({
        path: '/home'})
      window.localStorage.removeItem('page')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/footer.vue